import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  add(payload, assigned = false) {
    const endpoint = assigned ? 'successCardAssigned' : 'successCard'
    return http.post(endpoints.get(endpoint, { ...payload }), payload?.data)
  },
  get(payload, assigned = false) {
    const endpoint = assigned ? 'getSuccessCardAssigned' : 'getSuccessCard'
    return http.get(endpoints.get(endpoint, { ...payload }))
  },
  editAddedSuccessCard(payload) {
    return http.post(endpoints.get('updateSuccessCard', { ...payload }), payload?.data)
  },
  sendToGiftGiver(payload) {
    return http.post(endpoints.get('sendToGiftGiver', { ...payload }))
  },
  privilegedUpdate(payload) {
    return http.post(endpoints.get('privilegedUpdateSuccessCard', { ...payload }), payload?.data)
  },
  sendBack(payload) {
    return http.post(endpoints.get('sendBackSuccessCard', { ...payload }))
  },
  correctionSendBack(payload, assigned = false) {
    const endpoint = assigned
      ? 'correctionSendBackSuccessCardAssigned'
      : 'correctionSendBackSuccessCard'
    return http.post(endpoints.get(endpoint, { ...payload }))
  },
  editOnSentBack(payload, assigned = false) {
    const endpoint = assigned ? 'correctionSuccessCardAssigned' : 'correctionSuccessCard'
    return http.post(endpoints.get(endpoint, { ...payload }), payload?.data)
  },
  addComment(payload, assigned = false) {
    const endpoint = assigned ? 'successCardCommentAssigned' : 'successCardComment'
    return http.post(endpoints.get(endpoint, { ...payload }), payload?.data)
  }
}
